function normalize(val, valmin, valmax, min, max) {
  return ((val - valmin) / (valmax - valmin)) * (max - min) + min
}

export { normalize }
